import { defineAsyncComponent } from 'vue';
import type { AppModule } from '@shared/presentation/router/composition.js';

/**
 * `uploads` feature: video uploads that keep going in the background, and the labels they owe.
 *
 * No screen of its own. What it has is an overlay, rendered by the shell on every screen, because
 * an upload outlives the dialog that started it and whichever screen somebody moves to meanwhile.
 * Loaded asynchronously, so the shell does not pull the whole feature in before the first paint.
 */
export const virtualProfilerUploadsModule: AppModule = {
  name: 'virtual-profiler-uploads',
  routes: [],
  overlays: [defineAsyncComponent(() => import('./presentation/UploadsOverlay.vue'))],
};
